/* <time-line>: year tabs, arrows and swipe for the timeline section. Selecting a slide block in the
   theme editor shows that slide. */
class TimeLine extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.timeline__slide')];
    this.items = [...this.querySelectorAll('[data-nav]')];
    this.controls = this.querySelector('.timeline__controls');
    this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-selected')));

    this.onClick = (event) => {
      const item = event.target.closest('[data-nav]');
      if (item) { this.select(Number(item.dataset.index)); return; }
      if (event.target.closest('[data-prev]')) this.select(this.index - 1);
      if (event.target.closest('[data-next]')) this.select(this.index + 1);
    };
    this.addEventListener('click', this.onClick);

    this.onKey = (event) => {
      if (!event.target.closest('[data-nav]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        const forward = (event.key === 'ArrowRight') !== (document.dir === 'rtl');
        this.select(this.index + (forward ? 1 : -1));
        this.items[this.index]?.focus();
        event.preventDefault();
      }
    };
    this.addEventListener('keydown', this.onKey);

    // Swipe on the slides
    const slider = this.querySelector('.timeline__slider');
    this.onTouchStart = (event) => { this.touchX = event.touches[0].clientX; this.touchY = event.touches[0].clientY; };
    this.onTouchEnd = (event) => {
      const t = event.changedTouches[0];
      const dx = t.clientX - this.touchX;
      const dy = t.clientY - this.touchY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + ((dx < 0) !== (document.dir === 'rtl') ? 1 : -1));
    };
    slider?.addEventListener('touchstart', this.onTouchStart, { passive: true });
    slider?.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.slider = slider;

    this.onBlockSelect = (event) => {
      const i = this.slides.indexOf(event.target);
      if (i >= 0) this.select(i);
    };
    this.addEventListener('shopify:block:select', this.onBlockSelect);
    this.sync(false);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKey);
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.slider?.removeEventListener('touchstart', this.onTouchStart);
    this.slider?.removeEventListener('touchend', this.onTouchEnd);
  }

  select(i) {
    const next = Math.max(0, Math.min(i, this.slides.length - 1));
    if (next === this.index) return;
    this.index = next;
    this.sync(true);
  }

  sync(scrollNav) {
    this.slides.forEach((slide, n) => {
      const selected = n === this.index;
      slide.classList.toggle('is-selected', selected);
      if (selected) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
    });
    this.items.forEach((item, n) => item.setAttribute('aria-current', String(n === this.index)));
    this.querySelector('[data-prev]')?.toggleAttribute('disabled', this.index === 0);
    this.querySelector('[data-next]')?.toggleAttribute('disabled', this.index === this.slides.length - 1);
    // phones: keep the selected tab visible in the sideways scroller
    const item = this.items[this.index];
    if (scrollNav && item && this.controls && this.controls.scrollWidth > this.controls.clientWidth) {
      this.controls.scrollTo({ left: Math.max(0, item.offsetLeft), behavior: 'smooth' });
    }
  }
}
if (!customElements.get('time-line')) customElements.define('time-line', TimeLine);
